export default __webpack_public_path__ + "4f94a4ae925910583ffc30df8ed8cfc9.png";